export type HeroLeaderboardPreviewRow = {
  key: string;
  author_name: string;
  author_source?: string | null;
  credibility_score: number;
  profit_rating: number;
  roi_pct: number;
  tier: string;
  win_percentage: number;
  total_picks: number;
  correct_picks: number;
};

export type ExpertRatingsPreviewRow = {
  rank: number;
  rank_change?: number | null;
  rank_movement_new?: boolean | null;
  author_name: string;
  author_source?: string | null;
  credibility_score: number;
  profit_rating: number;
  roi_pct: number;
  correct_picks: number;
  incorrect_picks: number;
  total_picks: number;
  win_percentage: number;
};

export type HotPickPreviewRow = {
  pick_name: string;
  pick_category?: string | null;
  pick_over_under?: string | null;
  pick_value?: string | null;
  pick_sport: string;
  total_picks: number;
  avg_expert_wcs: number;
  credibility_weighted_score: number;
  headline: string;
};

export const HERO_LEADERBOARD_PREVIEW_ROWS: HeroLeaderboardPreviewRow[] = [
  {
    key: 'alex-carter',
    author_name: 'Alex Carter',
    author_source: 'discord',
    credibility_score: 92,
    profit_rating: 97.8,
    roi_pct: 192,
    tier: 'elite',
    win_percentage: 62.4,
    total_picks: 1244,
    correct_picks: 776,
  },
  {
    key: 'jordan-mills',
    author_name: 'Jordan Mills',
    author_source: 'twitter',
    credibility_score: 90,
    profit_rating: 91.2,
    roi_pct: 156,
    tier: 'proven',
    win_percentage: 59.8,
    total_picks: 987,
    correct_picks: 590,
  },
  {
    key: 'casey-brooks',
    author_name: 'Casey Brooks',
    author_source: 'discord',
    credibility_score: 76.1,
    profit_rating: 86.5,
    roi_pct: 87.2,
    tier: 'proven',
    win_percentage: 57.3,
    total_picks: 164,
    correct_picks: 94,
  },
  {
    key: 'riley-hayes',
    author_name: 'Riley Hayes',
    author_source: 'twitter',
    credibility_score: 71.8,
    profit_rating: 78.3,
    roi_pct: 42.1,
    tier: 'rising',
    win_percentage: 55.6,
    total_picks: 143,
    correct_picks: 79,
  },
  {
    key: 'morgan-lee',
    author_name: 'Morgan Lee',
    author_source: 'discord',
    credibility_score: 68.4,
    profit_rating: 72.5,
    roi_pct: 18.3,
    tier: 'one_to_watch',
    win_percentage: 54.1,
    total_picks: 127,
    correct_picks: 69,
  },
];

export const EXPERT_RATINGS_PREVIEW_ROWS: ExpertRatingsPreviewRow[] = [
  {
    rank: 1,
    rank_change: 2,
    author_name: 'Alex Carter',
    author_source: 'discord',
    credibility_score: 84.2,
    profit_rating: 97.8,
    roi_pct: 195.6,
    correct_picks: 136,
    incorrect_picks: 82,
    total_picks: 218,
    win_percentage: 62.4,
  },
  {
    rank: 2,
    rank_change: -1,
    author_name: 'Jordan Mills',
    author_source: 'twitter',
    credibility_score: 79.6,
    profit_rating: 91.2,
    roi_pct: 123.4,
    correct_picks: 115,
    incorrect_picks: 77,
    total_picks: 192,
    win_percentage: 59.8,
  },
  {
    rank: 3,
    rank_movement_new: true,
    author_name: 'Casey Brooks',
    author_source: 'discord',
    credibility_score: 76.1,
    profit_rating: 86.5,
    roi_pct: 87.2,
    correct_picks: 94,
    incorrect_picks: 70,
    total_picks: 164,
    win_percentage: 57.3,
  },
  {
    rank: 4,
    rank_change: 0,
    author_name: 'Riley Hayes',
    author_source: 'twitter',
    credibility_score: 71.8,
    profit_rating: 78.3,
    roi_pct: 42.1,
    correct_picks: 79,
    incorrect_picks: 64,
    total_picks: 143,
    win_percentage: 55.6,
  },
  {
    rank: 5,
    rank_change: 1,
    author_name: 'Morgan Lee',
    author_source: 'discord',
    credibility_score: 68.4,
    profit_rating: 72.5,
    roi_pct: 18.3,
    correct_picks: 69,
    incorrect_picks: 58,
    total_picks: 127,
    win_percentage: 54.1,
  },
  {
    rank: 6,
    rank_change: -2,
    author_name: 'Taylor Reed',
    author_source: 'twitter',
    credibility_score: 66.9,
    profit_rating: 68.8,
    roi_pct: 6.4,
    correct_picks: 61,
    incorrect_picks: 54,
    total_picks: 115,
    win_percentage: 53.0,
  },
  {
    rank: 7,
    rank_change: 0,
    author_name: 'Sam Ortiz',
    author_source: 'discord',
    credibility_score: 64.5,
    profit_rating: 65.2,
    roi_pct: -4.8,
    correct_picks: 58,
    incorrect_picks: 52,
    total_picks: 110,
    win_percentage: 52.7,
  },
  {
    rank: 8,
    rank_change: 3,
    author_name: 'Drew Patel',
    author_source: 'twitter',
    credibility_score: 62.1,
    profit_rating: 61.7,
    roi_pct: -12.5,
    correct_picks: 52,
    incorrect_picks: 49,
    total_picks: 101,
    win_percentage: 51.5,
  },
];

export const HOT_PICKS_PREVIEW_ROWS: HotPickPreviewRow[] = [
  {
    pick_name: 'Marcus Thompson',
    pick_category: 'points',
    pick_over_under: 'O',
    pick_value: '24.5',
    pick_sport: 'nba',
    total_picks: 6,
    avg_expert_wcs: 78.4,
    credibility_weighted_score: 470,
    headline: 'Marcus Thompson O 24.5 Points',
  },
  {
    pick_name: 'KC Chiefs',
    pick_category: 'spread',
    pick_over_under: 'U',
    pick_value: '3.5',
    pick_sport: 'pfb',
    total_picks: 5,
    avg_expert_wcs: 74.2,
    credibility_weighted_score: 371,
    headline: 'KC Chiefs U 3.5 Spread',
  },
  {
    pick_name: 'Aaron Judge',
    pick_category: 'total_bases',
    pick_over_under: 'O',
    pick_value: '1.5',
    pick_sport: 'mlb',
    total_picks: 4,
    avg_expert_wcs: 71.6,
    credibility_weighted_score: 286,
    headline: 'Aaron Judge O 1.5 Total Bases',
  },
  {
    pick_name: 'Nikola Jokic',
    pick_category: 'assists',
    pick_over_under: 'O',
    pick_value: '8.5',
    pick_sport: 'nba',
    total_picks: 7,
    avg_expert_wcs: 81.2,
    credibility_weighted_score: 568,
    headline: 'Nikola Jokic O 8.5 Assists',
  },
  {
    pick_name: 'Buffalo Bills',
    pick_category: 'moneyline',
    pick_over_under: 'O',
    pick_value: '',
    pick_sport: 'pfb',
    total_picks: 3,
    avg_expert_wcs: 69.8,
    credibility_weighted_score: 209,
    headline: 'Buffalo Bills Moneyline',
  },
];

export type TodaysEdgePreviewItem = {
  sport: string;
  category_label: string;
  direction: 'over' | 'under';
  win_pct: number;
  edge_pct: number;
  total_picks: number;
  confidence: 'high' | 'medium' | 'low';
  has_games_today: boolean;
};

export const TODAYS_EDGE_PREVIEW_ITEMS: TodaysEdgePreviewItem[] = [
  {
    sport: 'nba',
    category_label: 'Points',
    direction: 'over',
    win_pct: 71.6,
    edge_pct: 21.6,
    total_picks: 142,
    confidence: 'high',
    has_games_today: true,
  },
  {
    sport: 'pfb',
    category_label: 'Pass Yards',
    direction: 'under',
    win_pct: 66.2,
    edge_pct: 16.2,
    total_picks: 98,
    confidence: 'high',
    has_games_today: true,
  },
  {
    sport: 'mlb',
    category_label: 'Total Bases',
    direction: 'over',
    win_pct: 64.8,
    edge_pct: 14.8,
    total_picks: 76,
    confidence: 'medium',
    has_games_today: true,
  },
  {
    sport: 'nba',
    category_label: 'Rebounds',
    direction: 'under',
    win_pct: 61.4,
    edge_pct: 11.4,
    total_picks: 64,
    confidence: 'medium',
    has_games_today: true,
  },
  {
    sport: 'pfb',
    category_label: 'Rush Yards',
    direction: 'over',
    win_pct: 59.1,
    edge_pct: 9.1,
    total_picks: 52,
    confidence: 'low',
    has_games_today: true,
  },
];
